<template>
  <div class="monitorPage">
    <p v-if="!treeVideo">{{ msg }}</p>
    <div class="videoBox" v-if="showVedio && treeVideo">
      <LivePlayer
        :videoUrl="treeVideo"
        autoplay
        live
        stretch
        playsinline
        webkit-playsinline
        x5-playsinline
        x-webkit-airplay="allow"
        class="mb10 mySelfVideo"
      ></LivePlayer>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import LivePlayer from "@liveqing/liveplayer";
export default {
  name: "monitor",
  props: ["device", "appType"],
  components: { LivePlayer },
  data() {
    return {
      msg: "未检测到监控设备",
      showVideoType: false,
      showVedio: false,
      treeVideo: "",
      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.device) {
        this.getVideoUrl(this.device);
      }
    });
  },
  methods: {
    getVideoUrl(device) {
      let _this = this;
      _this.$api.slbkOldTree
        .getVideoSurveillance(
          device,
          false,
          { type: _this.clientType == "android" ? "flv" : "m3u8" },
          _this.appType
        )
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            let _videoUrl = res.data;
            // this.$nextTick(() => {
            if (_videoUrl) {
              _this.showVideoType = true;
              _this.showVedio = true;
              _this.treeVideo = _videoUrl;
            }
            // });
          } else {
            _this.showVedio = false;
            _this.showVideoType = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    device: function (id) {
      if (id) {
        this.getVideoUrl(id);
      }
    },
  },
};
</script>
<style lang="less">
.monitorPage {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  p {
    width: 60%;
    height: 40px;
    line-height: 40px;
    color: #333;
    text-align: center;
    font-size: 22px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  .videoBox {
    width: 100%;
    position: absolute;
    top: 30%;
    left: 0;
    .mySelfVideo {
      width: 100%;
      height: 200px;
      position: relative;

      .vjs-big-play-button {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }
}
</style>